import { LegalLayout } from "@/components/site/LegalLayout";
import { legal } from "@/config/content";

export default function Impressum() {
  return (
    <LegalLayout title="Impressum">
      <p>{legal.brandLine}</p>

      <h2>Angaben gemäß § 5 DDG</h2>
      <p>
        {legal.companyName}<br />
        {legal.street}<br />
        {legal.postalCity}<br />
        {legal.country}
      </p>

      <h2>Vertreten durch</h2>
      <p>Geschäftsführer: {legal.managingDirector}</p>

      <h2>Kontakt</h2>
      <p>
        Telefon: {legal.phone}<br />
        E-Mail: {legal.email}
      </p>

      <h2>Registereintrag</h2>
      <p>
        Registergericht: {legal.registerCourt}<br />
        Handelsregister: {legal.register}
      </p>

      <h2>Umsatzsteuer-Identifikationsnummer</h2>
      <p>
        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
        {legal.vatId}
      </p>

      <h2>Redaktionell verantwortlich</h2>
      <p>
        {legal.managingDirector}<br />
        {legal.companyName}, {legal.street}, {legal.postalCity}
      </p>

      <h2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
      <p>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </LegalLayout>
  );
}
